import { render, staticRenderFns } from "./responsibleRoles.vue?vue&type=template&id=7a337423"
import script from "./responsibleRoles.vue?vue&type=script&lang=js"
export * from "./responsibleRoles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports